import { useSelector } from "app/hooks";

export const useReportingPeriodScreen = () => {
  const { years: reportingPeriod } = useSelector(
    (state) => state.reportingPeriod
  );
  const { product } = useSelector((state) => state.investmentDetails);
  const continuteButtonDisabled = reportingPeriod === undefined;
  const continueUrl = continuteButtonDisabled ? "" : "/customisereport";
  const redirectHome = !product;

  return {
    reportingPeriod,
    continueUrl,
    continuteButtonDisabled,
    redirectHome,
  };
};
